import {Component, EventEmitter, Input} from '@angular/core';
import {ModalComponent} from '../modal-service.service';

@Component({
    selector: 'nlr-warning-modal',
    imports: [],
    templateUrl: './warning-modal.component.html',
    styleUrls: ['../modal.scss', './warning-modal.component.scss']
})
export class WarningModalComponent implements ModalComponent {
    modalClosed: EventEmitter<string> = new EventEmitter();
    @Input() modalSize: string;
    @Input() title: string;
    @Input() message: string;

    closeDialog() {
        this.modalClosed.emit('Close dialog');
    }

    setTitle(title: string) {
        this.title = title;
    }

    setMessage(message: string) {
        this.message = message;
    }

    save() {
        this.modalClosed.emit('yes');
    }

    cancelSave() {
        this.modalClosed.emit('no');
    }
}
